import { Routes } from '@angular/router';

import { Login } from './pages/login/login';
import { MainMenu } from './layout/main-menu/main-menu';
import { authGuard } from './core/guards/auth.guard';


export const routes: Routes = [
  {
    path: 'login',
    component: Login,
  },
  {
    path: '',
    component: MainMenu,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/home/home').then(m => m.Home),
      },
      {
        path: 'invitation',
        loadComponent: () => import('./pages/invitation/invitation').then(m => m.InvitationComponent),
      },
      {
        path: 'register',
        loadComponent: () => import('./pages/preregistration/preregistration').then(m => m.PreregistrationComponent),
      },
      {
        path: 'register/new',
        loadComponent: () => import('./pages/preregistration/form-register/form-register').then(m => m.FormRegisterComponent),
      },
      {
        path: 'lockers',
        loadComponent: () => import('./pages/lockers/lockers').then(m => m.LockersComponent),
      }
    ],
  },
];
